<template>

    <body style="direction: rtl; text-align: right;">
        <Header pageTitle="اضافة" />

        <div v-if="isLoading" class="loading-overlay">
            <div class="spinner"></div>
        </div>

        <div class="container" v-else>
            <router-link to="/home" class="btn mb-3" style="background-color: #b1cedf; color: #000;">
                عودة للصفحة الرئيسية
            </router-link>
            <form @submit.prevent="submitPost">
                <div class="mb-3">
                    <label for="postTitle" class="form-label">عنوان المنشور</label>
                    <input id="postTitle" type="text" class="form-control" v-model="postData.title"
                        placeholder="اكتب عنوان المنشور..." required />
                </div>
                <div class="mb-3">
                    <label for="postDescription" class="form-label">وصف المنشور</label>
                    <textarea id="postDescription" class="form-control" rows="4" v-model="postData.description"
                        placeholder="اكتب وصف المنشور..." required></textarea>
                </div>
                <div class="mb-3">
                    <label for="citySelect" class="form-label">اختر المدينة</label>
                    <select id="citySelect" class="form-select" v-model="postData.cityid" required>
                        <option value="">اختر مدينة...</option>
                        <option v-for="city in cities" :key="city.city_id" :value="city.city_id">
                            {{ city.city_name }}
                        </option>
                    </select>
                </div>
                <div class="mb-3">
                    <label for="categorySelect" class="form-label">اختر الفئة</label>
                    <select id="categorySelect" class="form-select" v-model="postData.categoriesid" required>
                        <option value="">اختر فئة...</option>
                        <option v-for="category in categories" :key="category.categories_id"
                            :value="category.categories_id">
                            {{ category.categories_name }}
                        </option>
                    </select>
                </div>
                <div class="mb-3">
                    <label for="postImages" class="form-label">إضافة صور (اختياري)</label>
                    <input type="file" id="postImages" class="form-control" multiple @change="handleImageUpload">
                </div>
                <button type="submit" class="mb-4 btn w-100"
                    style="background-color: #286090; color: #fff;">نشر</button>
            </form>
        </div>
    </body>
</template>

<script>
import axios from "axios";
import Header from "../../components/header.vue";

export default {
    name: "ProfessionPage",
    components: {
        Header,
    },
    data() {
        return {
            isLoading: true,
            postData: {
                title: "",
                description: "",
                cityid: null,
                categoriesid: "",
                usersid: "",
                createddate: new Date(new Date().getTime() + 3 * 60 * 60 * 1000).toISOString().slice(0, 19).replace("T", " "),
                images: [],
            },
            cities: [],
            categories: [],
        };
    },
    mounted() {
        this.fetchCitiesAndCategories();
        const userId = localStorage.getItem("userId");
        this.postData.usersid = userId ? parseInt(userId) : null;
    },
    methods: {
        async fetchCitiesAndCategories() {
            this.isLoading = true;
            try {

                const citiesResponse = await axios.get("https://zadcodeonline.com/ahmad/etqan/backEnd/city/view.php");
                this.cities = citiesResponse.data.data;


                const categoriesResponse = await axios.get("https://zadcodeonline.com/ahmad/etqan/backEnd/categories/view.php");
                this.categories = categoriesResponse.data.data;
            } catch (error) {
                console.error("Error fetching cities or categories:", error);
            } finally {
                this.isLoading = false;
            }
        },
        async submitPost() {
            this.isLoading = true;
            try {
                // التحقق من أن جميع الحقول مملوءة
                if (!this.postData.title || !this.postData.description || !this.postData.cityid || !this.postData.categoriesid) {
                    alert("يرجى ملء جميع الحقول المطلوبة");
                    return;
                }

                const formData = new FormData();
                formData.append("title", this.postData.title);
                formData.append("description", this.postData.description);
                formData.append("cityid", this.postData.cityid);
                formData.append("categoriesid", this.postData.categoriesid);
                formData.append("usersid", this.postData.usersid);
                formData.append("createddate", this.postData.createddate);

                // إضافة الصور إذا كانت موجودة
                if (this.postData.images.length > 0) {
                    this.postData.images.forEach((image) => {
                        formData.append(`images[]`, image); // استخدام images[] لإرسال مصفوفة من الصور
                    });
                }

                // عرض البيانات المرسلة في الكونسول
                for (let [key, value] of formData.entries()) {
                    console.log(key, value);
                }

                // إرسال البيانات إلى الخادم
                const response = await axios.post(
                    "https://zadcodeonline.com/ahmad/etqan/backEnd/posts/add.php",
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data', // تحديد نوع المحتوى
                        },
                    }
                );

                // التحقق من استجابة الخادم
                if (response.data.status === "success") {
                    alert("تم نشر المنشور بنجاح!");
                    this.$router.push("/home");
                } else {
                    alert("حدث خطأ أثناء النشر: " + response);
                }
            } catch (error) {
                if (error.response) {
                    console.error("Error response data:", error.response);
                } else {
                    console.error("Error message:", error.message);
                    alert("حدث خطأ أثناء النشر: " + error.message);
                }
            } finally {
                this.isLoading = false;
            }
        },
        handleImageUpload(event) {
            const files = event.target.files;
            const maxSize = 5 * 1024 * 1024; // 5MB
            for (let file of files) {
                if (file.size > maxSize) {
                    alert("حجم الصورة يجب أن يكون أقل من 5MB");
                    return;
                }
            }
            this.postData.images = Array.from(files);
        }

    },
};
</script>




<style scoped>
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.spinner {
    width: 50px;
    height: 50px;
    border: 5px solid #ccc;
    border-top: 5px solid #296080;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}




.card-header {
    padding: 0.25rem 0.25rem;
    margin-bottom: 0;
    background-color: #fff;
    border-bottom: 1px solid rgba(0, 0, 0, 0.09);
}

.card[data-v-b966fbcc] {
    background-color: #faf9f8;
    border-radius: 30px;
    padding: 1px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.hstack {
    display: flex;
    flex-direction: column;
}

body {
    padding: 70px 20px 0 20px;
}

a {
    color: #804529;
}

.navbar-light .navbar-nav .nav-link {
    color: #ffffff;
}


footer {
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #f8f9fa;
    padding: 20px;
    text-align: center;
}

.card-header {
    border-radius: 30px;
}

h3 {
    margin: 40px 0 0;
}

ul {
    list-style-type: none;
    padding: 0;
}

li {
    display: inline-block;
    margin: 0 10px;
}

a {
    color: #296080;
}

.text-itkan {
    font-size: 25px;
    color: #ffffff;
}

.text-person {
    color: #296080;
}

.text-date {
    font-size: 10px;
    color: #2e2e2e;
}

.rounded-card {
    border-radius: 25px;
    overflow: hidden;
}

.carousel-item img {
    border-radius: 30px;
    height: 200px;
    object-fit: cover;
}

/* إضافة قواعد جديدة أو تعديل القواعد الموجودة */
.card {
    background-color: #f8f9fa;
    /* لون فضي */
    border-radius: 15px;
    /* حواف دائرية */
    padding: 15px;
    /* إضافة مسافة داخلية */
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    /* إضافة ظل للكرت */
}


@media (max-width: 576px) {
    .carousel-item img {
        border-radius: 30px;
        height: 200px;
        object-fit: cover;
    }
}


@media (max-width: 768px) {
    .navbar-light .navbar-nav .nav-link[data-v-5e4cad4c] {
        color: #296080;
    }

    .navbar>.container,
    .navbar>.container-fluid,
    .navbar>.container-sm,
    .navbar>.container-md,
    .navbar>.container-lg,
    .navbar>.container-xl,
    .navbar>.container-xxl {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: inherit;
        flex-wrap: inherit;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        flex-direction: row-reverse;
    }
}
</style>